import { useTranslation } from "react-i18next";
import FadeInSection from "@/components/base/FadeInSection";

export default function BenefitsSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-secondary-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <FadeInSection delay={0}>
          <div className="mb-4">
            <span className="font-heading text-xs md:text-sm tracking-[0.2em] text-foreground-400 uppercase">
              {t("benefits.brand")}
            </span>
          </div>
        </FadeInSection>

        <FadeInSection delay={100}>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-semibold text-foreground-950 mb-10 md:mb-14 max-w-2xl leading-tight">
            {t("benefits.title")}
          </h2>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <FadeInSection delay={200} className="h-full">
            <div className="bg-foreground-950 rounded-3xl p-6 md:p-8 flex flex-col justify-between min-h-[280px] group hover:bg-foreground-900 transition-colors">
              <div>
                <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-6">
                  <span className="text-white text-sm font-semibold font-heading">01</span>
                </div>
                <h3 className="text-white font-heading text-xl md:text-2xl font-semibold mb-3">
                  {t("benefits.card_1_title")}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  {t("benefits.card_1_desc")}
                </p>
              </div>
            </div>
          </FadeInSection>

          <FadeInSection delay={300} className="h-full">
            <div
              className="bg-cover bg-center rounded-3xl p-6 md:p-8 flex flex-col justify-end min-h-[280px] relative overflow-hidden group"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20flowing%20data%20streams%20in%20warm%20amber%20and%20golden%20tones%20weaving%20through%20deep%20charcoal%20space%2C%20minimalist%20modern%20infographic%20visualization%2C%20elegant%20curved%20lines%20and%20glowing%20nodes%2C%20professional%20business%20analytics%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20no%20text%20no%20logos&width=800&height=600&seq=benefit-data-v2&orientation=landscape')`,
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-white/90 text-xs mb-4">
                  <i className="ri-bar-chart-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span>Comparison</span>
                </div>
                <h3 className="text-white font-heading text-xl md:text-2xl font-semibold">
                  {t("benefits.card_2_title")}
                </h3>
              </div>
            </div>
          </FadeInSection>

          <FadeInSection delay={400} className="h-full">
            <div className="bg-background-50 border border-background-200 rounded-3xl p-6 md:p-8 flex flex-col justify-between min-h-[280px]">
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
                  {t("benefits.card_3_title")}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                  {t("benefits.card_3_desc")}
                </p>
              </div>
              <div className="w-full h-24 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20upward%20trending%20abstract%20line%20graph%20in%20warm%20golden%20amber%20tones%20on%20clean%20cream%20background%2C%20simple%20elegant%20financial%20data%20visualization%2C%20smooth%20flowing%20curve%2C%20modern%20business%20analytics%2C%20no%20text%20no%20labels%2C%20serene%20aesthetic&width=600&height=200&seq=benefit-chart-v2&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}